import Breadcrumb from "components/Common/Breadcrumb2"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import List from "./Components/List"
import NewProfile from "./Components/NewProfile"
import UpdateProfile from "./Components/UpdateProfile"

const Perfis = props => {
  document.title = "Perfis | Sensetek"
  let { id } = useParams()
  const [activeTab, setActiveTab] = useState(id ? 2 : 0)
  const [reRenderList, setReRenderList] = useState(false)
  let history = useHistory()

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Perfis"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Perfis
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <br className="mt-1" />
                      <Nav pills className="navtab-bg nav-justified">
                        {activeTab !== 0 && <div className="vr"></div>}
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            active={activeTab === 0}
                            onClick={() => {
                              setActiveTab(0)
                              history.push("/configuracoes/acessos/perfis")
                            }}
                          >
                            Lista de Perfis
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{ cursor: "pointer" }}
                            active={activeTab === 1}
                            onClick={() => {
                              setActiveTab(1)
                              history.push("/configuracoes/acessos/perfis")
                            }}
                          >
                            Novo Perfil
                          </NavLink>
                        </NavItem>
                        {activeTab !== 1 && <div className="vr"></div>}
                      </Nav>
                      <TabContent
                        activeTab={activeTab}
                        className="p-3 text-muted"
                      >
                        <TabPane tabId={0}>
                          <Row>
                            <Col sm="12">
                              <List
                                reRender={reRenderList}
                                setNav={setActiveTab}
                              ></List>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId={1}>
                          <Row>
                            <Col sm="12">
                              <NewProfile
                                reRenderList={reRenderList}
                                setReRenderList={setReRenderList}
                                setNav={setActiveTab}
                              ></NewProfile>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId={2}>
                          <Row>
                            <Col sm="12">
                              {id && (
                                <UpdateProfile
                                  reRenderList={reRenderList}
                                  setReRenderList={setReRenderList}
                                  setNav={setActiveTab}
                                ></UpdateProfile>
                              )}
                            </Col>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Perfis.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Perfis)
